import React from "react";
import axios from "axios";
import {header} from "../Url/ApiUrl";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";

const CompanyStatus = ({ user, setUser }) => {
    const { t } = useTranslation();
    const sendToCheck = () => {
        axios.post(
            process.env.REACT_APP_API_ENDPOINT+'/company/sendtocontrol', {},{headers:header})
            .then(response=>{
                if(response){
                    if(response.data){
                        if(response.data.success){
                            swal(t('success'), response.data?.message, "success", {
                                buttons: false,
                                timer: 2000,
                            }).then(()=>{
                                    window.location.reload()
                                }
                            )
                        }else{
                            swal(t('error'), response.data?.message, "error", {
                                buttons: true,
                                timer: 20000,
                            })
                        }
                    }
                }else{
                    swal(t('error'), t('something_went_wrong'), "error", {
                        buttons: false,
                        timer: 2000,
                    })
                }
            })
            .catch(err=>{
                console.log("Error",err)
            })
    }


    if (!user.companyStatus || user.companyStatus === 1) {
        return (
            <div className="alert alert-warning alert-custom" role="alert">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <i className="ri-error-warning-line"></i>
                        <span>
                            {t('data_not_filled')}! (
                            <small>
                                <i>
                                    <b>
                                        {t('fill_and_send_to_view')}
                                    </b>
                                </i>
                            </small>
                            )
                        </span>
                    </div>
                    {user.hasService && (
                        <div>
                            <button type="submit" onClick={sendToCheck} className="btn btn-outline-primary">
                                {t('send_to_preview')}
                            </button>
                            {/*</form>*/}
                        </div>
                    )}
                </div>
            </div>
        );
    } else if (user.companyStatus === 2) {
        return (
            <div className="alert alert-warning alert-custom" role="alert">
                <div className="d-flex align-items-center">
                    <i className="ri-error-warning-line"></i>
                    <span>{t('in_view_process')}</span>
                </div>
            </div>
        );
    } else if (user.companyStatus >= 3) {
        return user.total_point > 59 ? (
            <div className="alert alert-success alert-custom" role="alert">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <i className="ri-checkbox-circle-fill"></i>
                        <span>{t('recommended')}</span>
                    </div>
                    <div>
                        <a
                            style={{ padding: "15px", color: "#000" }}
                            href="https://lex.uz/docs/5884584"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('qaror')}
                        </a>
                    </div>
                </div>
            </div>
        ) : (
            <div className="alert alert-danger alert-custom" role="alert">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <i className="ri-error-warning-line"></i>
                        <span>{t('not_recommended')}</span>
                    </div>
                    <div>
                        <a
                            style={{ padding: "15px", color: "black" }}
                            href="https://lex.uz/docs/5884584"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('qaror')}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default CompanyStatus;